export default "__VITE_ASSET__BO3xH86V__"